import { Injectable } from "@angular/core";
import { type EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import type { IClientMessage } from "../model/client-message.model";

export interface ClientMessageState extends EntityState<
    IClientMessage,
    number
> {}

@Injectable({ providedIn: "root" })
@StoreConfig({
    name: "client-message",
    resettable: true,
    cache: {
        ttl: 300000, // 5 mins
    },
})
export class ClientMessageStore extends EntityStore<ClientMessageState> {
    constructor() {
        super();
    }
}
